import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatPLN, formatDate } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";

const FILTERS = [
  { key: "all", label: "Wszystkie", status: null },
  { key: "zaakceptowane", label: "Do realizacji", status: "zaakceptowane" },
  { key: "w_realizacji", label: "W realizacji", status: "w_realizacji" },
  { key: "zrealizowane", label: "Zrealizowane", status: "zrealizowane" },
];

export default function AdminApprovedOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = (key) => {
    const cfg = FILTERS.find((f) => f.key === key);
    const params = cfg?.status ? { status_filter: cfg.status } : {};
    api.get("/orders", { params }).then((r) => setOrders(r.data));
  };

  useEffect(() => { load(filter); }, [filter]);

  return (
    <div>
      <PageHeader testId="admin-orders" title="Zamówienia zaakceptowane" subtitle="Zarządzaj statusem realizacji" />

      <div className="flex gap-2 mb-4 overflow-x-auto" data-testid="status-filters">
        {FILTERS.map((f) => (
          <button key={f.key} onClick={() => setFilter(f.key)} data-testid={`filter-${f.key}`}
            className={`px-3 py-1.5 rounded-md text-xs font-semibold whitespace-nowrap transition-colors ${
              filter === f.key ? "bg-[#FF6B1A] text-white" : "bg-white border border-slate-300 text-slate-700 hover:border-slate-400"
            }`}>{f.label}</button>
        ))}
      </div>

      <div className="ol-card overflow-hidden">
        {orders.length === 0 ? (
          <div className="p-12 text-center text-sm text-slate-500">Brak zamówień w tej kategorii.</div>
        ) : (
          <table className="ol-table" data-testid="admin-orders-table">
            <thead>
              <tr><th>Numer</th><th>Budowa</th><th>Pracownik</th><th>Zaakceptowane</th><th className="text-right">Wartość</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td className="font-mono text-xs">{o.order_number}</td>
                  <td>{o.site_name}</td>
                  <td>{o.created_by_name}</td>
                  <td className="text-xs text-slate-600">{formatDate(o.approved_at)}</td>
                  <td className="text-right font-semibold">{formatPLN(o.final_total_net)}</td>
                  <td><StatusBadge status={o.status} /></td>
                  <td><Link to={`/orders/${o.id}`} className="ol-link text-xs">Szczegóły</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
